import $ from 'jquery';

export default class SplashScreenHandler {
  constructor(config) {
    this._container = config.container;
    this._init();
  }

  _init() {
    var splashScreen = this._container;

    $(window).on('beforeunload', function(event) {
      var activeElement = $(event.target.activeElement);
      if (activeElement.is('[href^="mailto:"]')) { return; }
      if (activeElement.is('[href^="tel:"]')) { return; }

      $('body').addClass('is-offscroll');

      splashScreen.css('opacity', 0);
      splashScreen.show();
      splashScreen.animate({ opacity: 1 }, 500);
    });
    $(window).on('load', function() {
      $('body').removeClass('is-offscroll');

      splashScreen.css('opacity', 1);
      splashScreen.animate({ opacity: 0 }, 500, function() {
        splashScreen.hide();
      });
    });
    $(window).on('pageshow', function() {
      if ($('body').hasClass('is-offscroll')) {
        $('body').removeClass('is-offscroll');
        splashScreen.animate({ opacity: 0 }, 500, function() {
          splashScreen.hide();
        });
      }
    });
  }
}
